import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Permissions } from 'src/app/core/enums/permissions.enum'

@Component({
  selector: 'app-customer-view-actions-bar',
  templateUrl: './customer-view-actions-bar.component.html',
  styleUrls: ['./customer-view-actions-bar.component.scss'],
  standalone: false,
})
export class CustomerViewActionsBarComponent {
  public readonly Permissions = Permissions

  @Input() public isDownloadVisible = false

  @Output() public toggleDownload = new EventEmitter<void>()
}
